import React from 'react';

const PngResizeDimensionsImagePreview = ({image}:{image?: string}) => {
    return (
        <img

            src={ image || "/images/png-resizer-feature.png"}
            alt="PNG-Resizer-Feature"
            className="w-full p-14"
        />
    );
};

export default PngResizeDimensionsImagePreview;